import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {
    type ConfirmPickupReturnsInput,
    confirmPickupReturnsRequestSchema,
    createdPickupJobSchema,
    type CreatePickupJobInput,
    createPickupJobRequestSchema,
    customerWorkSchema,
    pickupConfirmationSchema,
    pickupReturnResultSchema,
    type PickupSoonerInput,
    pickupSoonerRequestSchema,
    pickupSoonerResultSchema,
    pickupsToConfirmSchema,
    pickupUnitSchema,
} from './schemas'

export async function listCustomerWork(customerId: string, includeClosedWork = false) {
    const query = includeClosedWork ? '?include_closed_work=true' : ''
    const raw = await apiFetch<unknown>(`/customers/${customerId}/work${query}`)
    return z.array(customerWorkSchema).parse(raw)
}

export async function listPickupCandidates(projectId: string) {
    const raw = await apiFetch<unknown>(`/projects/${projectId}/pickup-candidates`)
    return z.array(pickupUnitSchema).parse(raw)
}

export async function createPickupJob(projectId: string, input: CreatePickupJobInput) {
    const raw = await apiFetch<unknown>(`/projects/${projectId}/pickup-jobs`, {
        method: 'POST',
        body: JSON.stringify(createPickupJobRequestSchema.parse(input)),
    })
    return createdPickupJobSchema.parse(raw)
}

export async function listPickupUnits(projectId: string, jobId: string) {
    const raw = await apiFetch<unknown>(`/projects/${projectId}/jobs/${jobId}/pickup-units`)
    return z.array(pickupUnitSchema).parse(raw)
}

export async function confirmPickupReturns(
    projectId: string,
    jobId: string,
    input: ConfirmPickupReturnsInput,
) {
    const raw = await apiFetch<unknown>(`/projects/${projectId}/jobs/${jobId}/pickup-returns`, {
        method: 'POST',
        body: JSON.stringify(confirmPickupReturnsRequestSchema.parse(input)),
    })
    return pickupReturnResultSchema.parse(raw)
}

export async function pickupSooner(projectId: string, input: PickupSoonerInput) {
    const raw = await apiFetch<unknown>(`/projects/${projectId}/pickup-sooner`, {
        method: 'POST',
        body: JSON.stringify(pickupSoonerRequestSchema.parse(input)),
    })
    return pickupSoonerResultSchema.parse(raw)
}

export async function confirmPickupReady(projectId: string, jobId: string) {
    const raw = await apiFetch<unknown>(
        `/projects/${projectId}/jobs/${jobId}/pickup-confirmation`,
        {method: 'POST'},
    )
    return pickupConfirmationSchema.parse(raw)
}

export async function listPickupsToConfirm(yardId: string | null) {
    const query = yardId ? `?yard_id=${encodeURIComponent(yardId)}` : ''
    const raw = await apiFetch<unknown>(`/dispatch/pickups-to-confirm${query}`)
    return pickupsToConfirmSchema.parse(raw)
}
